import styled from 'styled-components';
import LiftSvg from '../../assets/amenities/lift.svg';

const LiftIcon = styled(LiftSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default LiftIcon;
